import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackEventListParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackEventList";

/* ---------------------------------------------------------------------------------------------------- */
// https://developers.google.com/analytics/devguides/collection/ga4/reference/events#add_to_cart
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackAddToCartItem extends Toolkit.GoogleAnalytics.AnyProductItem {}

export interface TrackAddToCartParameters
    extends TrackEventListParameters<"currency" | "value", null, TrackAddToCartItem> {}

const trackAddToCart = (parameters: TrackAddToCartParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    const action: Toolkit.GoogleAnalytics.AnyEventName = "add_to_cart";
    const data = ga.track.eventList({ action, ...parameters }, { ...options, skipTracking: true });

    return ga.track.eventList({ action, ...data, items: data.items?.filter(x => !x.inactive) }, options);
};

export default trackAddToCart;
